@if (oppgave) {
  <kommentar-traader [forelder]="oppgave.id"/>
  <ny-kommentar-traad [gruppeId]="oppgave.eiendeGruppeId"
                      (vedFulltSkjemaAktivert)="nyTraadFullSkjemaAktivert($event)"
                      [hidden]="oppgave.kommentarer.length > 0 || visNyTraadSkjema"/>
}
